export var TrackType;
(function (TrackType) {
    TrackType[TrackType["Noop"] = 0] = "Noop";
    TrackType[TrackType["HTML"] = 100] = "HTML";
    TrackType[TrackType["Mouse"] = 200] = "Mouse";
    TrackType[TrackType["Keyboard"] = 300] = "Keyboard";
    TrackType[TrackType["Console"] = 400] = "Console";
    TrackType[TrackType["Error"] = 500] = "Error";
    TrackType[TrackType["Network"] = 600] = "Network";
    TrackType[TrackType["Insight"] = 700] = "Insight";
    TrackType[TrackType["Performance"] = 800] = "Performance";
})(TrackType || (TrackType = {}));
export function isCustomTrackType(input) {
    return input >= 1001 && input <= 1999;
}
export function checkCustomTrackType(type) {
    if (!isCustomTrackType(type)) {
        throw new Error('custom tracker type must be in range [1001 ~ 1999].');
    }
    return type;
}
